<template>
  <div class="payWay">
    <div class="box">
      <p class="title">请选择支付方式</p>
      <ul class="list">
        <li v-for="(item, index) in way" :key="index">
          <div class="left">
            <img :src="item.icon" alt="">
            <p>{{item.name}} {{item.name === '账户余额' ? '('+userBaseInfo.smallChange+')' : ''}}</p>
          </div>
          <div class="right">
            <img v-if="select === index" src="../../assets/images/courier/xuanzhong.png" alt="" @click="isSelect(index)">
            <img v-else src="../../assets/images/courier/meixuan.png" alt="" @click="isSelect(index)">
          </div>
        </li>
      </ul>
      <input class="pwd" type="password" placeholder="请输入支付密码" :readonly="select === 0 ? false : true" v-model="password">
      <button class="pay" @click="pay">支付</button>
      <img class="icon" src="../../assets/images/courier/close.png" alt="" @click="close">
    </div>
    <pay-code v-if="isShow" @closeCode="closeCode" />
  </div>
</template>

<script>
import PayCode from '../../components/Pay/PayCode'
import {mapState} from 'vuex'
export default {
  data() {
    return {
      isShow: false,
      select:0,
      way: [
        {icon: require('../../assets/images/person/yue.png'), name: '账户余额'},
        {icon: require('../../assets/images/person/wechat.png'), name: '微信支付'},
        {icon: require('../../assets/images/person/pay.png'), name: '支付宝'}
      ],
      password: ''
    }
  },
  created() {
    this.$store.dispatch('recordUserBaseInfo')
  },
  methods: {
    // 选中支付方式
    isSelect (i) {
      this.select = i
    },
    // 点击关闭支付方式
    close () {
      this.$emit('close')
    },
    // 点击关闭支付二维码
    closeCode () {
      this.isShow = !this.isShow
    },
    // 支付
    pay () {
      if(this.select === 0) {
        if(!this.password){
          this.$message({
            message: '支付密码不能为空',
            type: 'error'
          })
        } else {
          const {paymentSn} = this.$store.state.orderInfo
          let query = `?paymentSn=${paymentSn}&payPwd=${this.password}`
          this.$store.dispatch('getBalancePay', query)
        }
      } else if(this.select === 1) {
        const {paymentSn} = this.$store.state.orderInfo
        let query = `?paymentSn=${paymentSn}`
        this.$store.dispatch('getWechatPay', query).then(() => {
          this.closeCode()
        })
      } else if(this.select === 2) {
        const {paymentSn} = this.$store.state.orderInfo
        let query = `?paymentSn=${paymentSn}`
        this.$store.dispatch('getAliPay', query).then(() => {
          // console.log(this.balancePay);
          // this.closeCode()
        })
      }
    }
  },
  computed: {
    ...mapState(['balancePay','userBaseInfo'])
  },
  components: {
    PayCode
  }
}
</script>

<style scoped lang="less" type="text/less">
  .payWay{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.5);
    z-index: 1000;
    .box{
      position: relative;
      width: 410px;
      margin:50px auto;
      padding:50px 30px 25px;
      background: #fff;
      border-radius:10px;
      box-sizing: border-box;
      .title{
        margin-bottom: 43px;
        text-align: center;
        font-size: 18px;
        font-weight: bold;
        color: #2c2c2c;
      }
      .list{
        li{
          display: flex;
          justify-content: space-between;
          width: 325px;
          height: 63px;
          margin: 0 auto 20px;
          padding:0 27px 0 17px;
          line-height: 63px;
          border:1px solid #f1f1f1;
          box-shadow:0px 3px 7px 0px rgba(0, 0, 0, 0.08);
          border-radius:4px;
          box-sizing: border-box;
          .left{
            display: flex;
            img{
              display: block;
              width: 22px;
              height: 22px;
              margin:21px 13px 0 0;
            }
          }
        }
      }
      .pwd{
        display: block;
        width: 100%;
        height: 50px;
        margin-top:30px;
        text-indent: 20px;
        font-size: 20px;
        border:1px solid #f1f1f1;
        background: #f1f1f1;
        border-radius:4px;
      }
      .pay{
        display: block;
        width: 192px;
        height: 48px;
        margin:30px auto 0;
        font-size: 18px;
        font-weight: bold;
        color: #fff;
        border: none;
        background: #61aee6;
        border-radius: 24px;
        box-shadow: 0px 5px 9px 0px rgba(0, 0, 0, 0.15);
      }
      .icon{
        position: absolute;
        top: 13px;
        right: 16px;
        cursor: pointer;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Pay/PayWay.vue